// extracted by mini-css-extract-plugin
export var createdDate = "_ml-1";
export var divider = "_ml-2";
export var headerDivider = "_ml-3";
export var messagesCard = "_ml-0";
export var messagesContainer = "_ml-6";
export var messagesContainerWrapper = "_ml-4";
export var showLeftPanelButton = "_ml-8";
export var topButtons = "_ml-7";
export var withPadding = "_ml-5";